import React from 'react';
import BeNavItem from './nav-item';
import { useLocation } from 'react-router-dom';

export default function BeNavGroup(props)  {
    const location = useLocation();
    return (
        <React.Fragment>
            {props.menu.map((item, key) => {
                return (
                    <React.Fragment>
                        <BeNavItem currentPath={location.pathname} nav={item} key={key} rootNav={true} /> 
                    </React.Fragment>
                );
            })} 
        </React.Fragment>
    );

}

